export default () => ({
  restrict: 'AE',
  scope: {},
  link: (scope, element, attrs, ctrls, transclude) => {
    const replaceElement = (transcludeElement) => element.replaceWith(transcludeElement)
    transclude(replaceElement, null, attrs.slot)
  }
})
